import { takeLatest, put } from 'redux-saga/effects';
import { getRequest } from '../../../utilities/requests';
import {
  LOAD_REFERRAL_BANK_DETAILS,
  setReferralBankDetails,
  setBankDetailsNew
} from './reducer';
import { history } from '../../../utilities/history';

export function* handleLoadReferralBankDetails() {
  try {
    // add validtaions on back end if user doesnt have a bank
    const response = yield getRequest('/referral_bank_details');
    if (response.data.referral_bank_detail) {
      yield put(setReferralBankDetails(response.data.referral_bank_detail));
    } else {
      yield put(setBankDetailsNew());
    }
  } catch (error) {
    history.push('/error');
  }
}

export function* loadReferralBankDetailsSaga() {
  yield takeLatest(LOAD_REFERRAL_BANK_DETAILS, handleLoadReferralBankDetails);
}
